const pending = {
    id: 0,
    label: 'Pending',
    iconClass: 'i-cm-pending',
};
const notSent = {
    id: 1,
    label: 'Not Sent',
    iconClass: '',
};
const failed = {
    id: 2,
    label: 'Failed',
    iconClass: 'i-cm-failure',
};
const success = {
    id: 3,
    label: 'Successful',
    iconClass: 'i-cm-check',
};

export default [
    pending,
    notSent,
    failed,
    success,
];

const indexedFaxStatuses = {
    0: pending,
    1: notSent,
    2: failed,
    3: success,
};

export {indexedFaxStatuses};



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-fax/fax-statuses.js